var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ValueTransformer_1 = __importDefault(require("./ValueTransformer"));
const trySerializeDate_1 = __importDefault(require("../trySerializeDate"));
function serializeDates(value, options = {}) {
    return new SerializeDates(options).transform(value);
}
class SerializeDates extends ValueTransformer_1.default {
    transformValue(val, options) {
        return (0, trySerializeDate_1.default)(val, options);
    }
}
exports.default = serializeDates;
//# sourceMappingURL=serializeDates.js.map